var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ICON/16/Line/Red/Warn"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 21419"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 8,
    cy: 8,
    r: 5.5,
    stroke: "#FF6161"
  }), /*#__PURE__*/React.createElement("path", {
    id: "!",
    d: "M8.474 9.6001L8.65464 5.58495L8.6998 4.6001H7.2998L7.34497 5.58495L7.52561 9.6001H8.474Z",
    fill: "#FF6161"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1",
    cx: 7.9998,
    cy: 10.7,
    r: 0.7,
    fill: "#FF6161"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcWarning);
export default __webpack_public_path__ + "static/media/ic_warning.91af4fc6276b3431fb6e8507b7d46dab.svg";
export { ForwardRef as ReactComponent };